import styled from 'styled-components';

export interface FlexContainerProps {
  display?: 'flex' | 'inline-flex';
  flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'normal';
  alignSelf?: 'stretch' | 'center' | 'start' | 'end';
  gap?: string;
  width?: string;
  height?: string;
  margin?: string;
  flex?: string;
  padding?: string;
  minHeight?: string;
  minWidth?: string;
  maxWidth?: string;
  maxHeight?: string;
  overflowY?: string;
}

export const FlexContainer = styled.div<FlexContainerProps>`
  display: ${({ display }) => display || 'flex'};
  ${({ flexDirection }) => (flexDirection ? `flex-direction: ${flexDirection}` : undefined)};
  ${({ alignSelf }) => (alignSelf ? `align-self: ${alignSelf}` : undefined)};
  ${({ flexWrap }) => (flexWrap ? `flex-wrap: ${flexWrap}` : '')};
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent}` : undefined)};
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems}` : undefined)};
  ${({ alignContent }) => (alignContent ? `align-content: ${alignContent}` : undefined)};
  ${({ gap }) => (gap ? `gap: ${gap}` : undefined)};
  ${({ width }) => (width ? `width: ${width}` : undefined)};
  ${({ height }) => (height ? `height: ${height}` : undefined)};
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight}` : undefined)};
  ${({ margin }) => (margin ? `margin: ${margin}` : undefined)};
  ${({ flex }) => (flex ? `flex: ${flex}` : undefined)};
  ${({ padding }) => (padding ? `padding: ${padding}` : undefined)};
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}px` : undefined)};
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}px` : undefined)};
  ${({ maxHeight }) => (maxHeight ? `max-height: ${maxHeight}` : undefined)};
  overflow-y: ${({ overflowY }) => overflowY ?? undefined};
`;
